export const exceptionReportConfigFieldlabels = {
  configID: 'Exception Report Config ID',
  applicationName: 'Application Name',
  mailID: 'Email',
  enableNotification: 'Enable Notification',
  metricType: 'Metric Type',
  reportType: 'Report Type',
  hours: 'Hours'
};
